"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CacheService: ()=>CacheService,
    getHref: ()=>getHref
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const getHref = (request)=>{
    if ('string' == typeof request) return request;
    if (request instanceof URL) return request.href;
    if (request instanceof Request) return request.url;
};
class CacheService {
    async match(request, options) {
        try {
            const instance = await this.cachePromise;
            if (instance) return await instance.match(request, options);
            if ('undefined' != typeof localStorage) {
                const key = getHref(request);
                if (key) {
                    const data = localStorage.getItem(key);
                    if (data) return new Response(data);
                }
            }
        } catch (e) {
            return;
        }
    }
    async put(request, response) {
        const instance = await this.cachePromise;
        if (instance) return await instance.put(request, response);
        if ('undefined' != typeof localStorage) {
            const key = getHref(request);
            const data = await response.text();
            if (key && data) localStorage.setItem(key, data);
        }
    }
    constructor(cacheName){
        _define_property(this, "cachePromise", void 0);
        if ('undefined' != typeof caches) this.cachePromise = caches.open(cacheName).catch((error)=>{
            console.error(error);
        });
    }
}
exports.CacheService = __webpack_exports__.CacheService;
exports.getHref = __webpack_exports__.getHref;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CacheService",
    "getHref"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
